import tw, { styled } from 'twin.macro';

export const FileInput = styled.input`
  ${tw`h-0 w-1 inline-block `}
  visibility: hidden;
`;
export const FileUploadWrapper = styled.div`
  ${tw`w-full flex`}
  // background: #F8F8F8;
  border-radius: 2px;
`;

export const FileUploadButton = styled.button`
  ${tw`cursor-pointer inline-block min-h-4 align-baseline 
text-center no-underline bg-transparent text-lightGray font-normal 
normal-case rounded leading-4 w-full border-none opacity-70
`};
  background: #f8f8f8;
  box-shadow: 0 0 0 1px rgba (34, 36, 38, 0.15) inset;
  padding: 1.2rem;
  :active {
    background: #f8f8f8;
    color: rgba(0, 0, 0, 0.9);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
  }
  :focus,
  :hover {
    background: #fff;
    color: rgba(0, 0, 0, 0.9);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
  }

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
  border-radius: var(--formFieldBorderRadius);
  background: var(--formFieldBackgroundColor, #f8f8f8);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;

  :hover {
    background: var(--formFieldBackgroundColor);
  }
`}

  &.isErroneous {
    border: 1px solid red;
  }
`;
export const FileText = styled.span`
  ${tw`text-black`}
  font-family: Circular Std !important;
  color: #777;
  word-wrap: break-word;
  display: block;
  width: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-size: var(--formFontSize);
    font-family: var(--formFontType) !important;
    color: var(--formFieldColor, var(--formTextColor));
  `}
`;

export const FileActionButton = styled.button`
  ${tw`text-red-500 cursor-pointer inline mb-0 outline-none border-none bg-transparent`}
  font-family: var(--formFontType) !important;
`;
